export default __webpack_public_path__ + "static/media/bg-flow-5.1bb5c222.png";